import React, { useState } from "react";
import { Col, Row } from "components/shared/layout";
import TextArea from "components/textarea";
import Input from "components/input";
import styled from "styled-components";
import { useFormikContext } from 'formik';
import _ from 'lodash';
import Select from "components/select";

const FormContainer = styled.div`
  width: 100%;
`;

const FieldWrapper = styled(Row)`
  padding: 10px;

  textarea {
    min-height: 200px;
  }
`;

const TeamMemberCountRow = styled(Row)`
  display: block !important;
`;

const NumTeamMemberSelect = styled.select`
  margin-left: 15px;
  width: 50px;
`;

const TeammateTitle = styled.h3`
  margin-top: 10px;
  margin-left: 10px;
`;

const Summary = () => {
  const { values, setValues } = useFormikContext();

  console.log('@@@ Summary formik values: ', values);

  function onChangeNumTeamMembers(e) {
    // update dynamic form
    const teamMembers = [...values.team_members];
    const numberOfTeamMembers = e.target.value || 0;
    const previousNumber = _.size(teamMembers);
    if (previousNumber < numberOfTeamMembers) {
        for (let i = previousNumber; i < numberOfTeamMembers; i++) {
            teamMembers.push({ name: '', email: '', gender: '' });
        }
    } else {
        for (let i = previousNumber; i >= numberOfTeamMembers; i--) {
            teamMembers.splice(i, 1);
        }
    }
    setValues({ ...values, team_members: teamMembers });

  };

  return (
    <FormContainer>
      <Row>
        <FieldWrapper xs={12}>
          <TextArea name="business_description" placeholder="Business description" />
        </FieldWrapper>
      </Row>
      <TeamMemberCountRow>
        <FieldWrapper xs={12}>
          <h3> Team Members: </h3>
          <NumTeamMemberSelect value={_.size(values.team_members)} onChange={e => onChangeNumTeamMembers(e)}>
            <option value=""></option>
            {[1,2,3,4,5,6,7,8,9,10].map(i => 
                <option key={i} value={i}>{i}</option>
            )}
          </NumTeamMemberSelect>
        </FieldWrapper>
      </TeamMemberCountRow>
      {_.map(values.team_members || [], (obj, idx) => (
        <Row>
          <TeammateTitle> Member {idx+1}: </TeammateTitle>
          <Col>
            <FieldWrapper xs={12}>
              <Select name={`team_members.${idx}.gender`} placeholder={obj.gender || 'gender'}
               options={['Male', 'Female', 'Prefer not to answer'].map(opt => ({ label: opt, value: opt }))}/>
          
            </FieldWrapper>
          </Col>
          <Col>
            <FieldWrapper xs={12}>
              
              <Input name={`team_members.${idx}.name`} placeholder={obj.name || 'Full name'} />
            </FieldWrapper>
          </Col>
          <Col>
            <FieldWrapper xs={12}>
              <Input name={`team_members.${idx}.email`} placeholder={obj.email || 'emailaddress@mail.com'} />
            </FieldWrapper>
          </Col>
        </Row>
      ))}
    </FormContainer>
  );
};
export default Summary;
